import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";
import { PromoMessage } from "@/types/data";

export const promoService = {
  async getAll(): Promise<PromoMessage[]> {
    const response = await axios.get<PromoMessage[]>(ApiRoutes.PROMO_MESSAGES);
    return response.data;
  },

  async create(data: PromoMessage[]) {
    const response = await axios.post(ApiRoutes.PROMO_MESSAGES, data);
    return response.data;
  },
};
